import React from "react";
import { ArrowLeft, Home, SearchX } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { PageHeader } from "../components/ApplicationShell";
import Button from "../components/Button";
import EmptyState from "../components/EmptyState";

export default function FourZeroFourPage() {
  const navigate = useNavigate();
  return (
    <>
      <PageHeader title="Page not found" />
      <main className="wsm-not-found">
        <div className="wsm-not-found__content">
          <EmptyState actions={<><Button icon={Home} onClick={() => navigate("/")}>Go to dashboard</Button><Button icon={ArrowLeft} onClick={() => navigate(-1)} variant="outline">Go back</Button></>}
            description="The page may have moved, been removed, or the address may be incorrect." icon={SearchX} title="Page not found" />
        </div>
      </main>
    </>
  );
}